// Core modules
import { Injectable } from '@angular/core';

// Application model and services
import { LoginModel } from '@shared/models/login.model';
import { ApiService } from './api.service';

export const TOKEN_NAME = 'kassa_admin_jwt_token';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  /**
   * Life cycle method
   * @param apiService instance of api service
   */
  constructor(private apiService: ApiService) {
  }

  /**
   * Function to login in to the application
   * @param loginData data to send in the request
   */
  login(loginData: LoginModel) {
    return this.apiService.post('/api/account/login', loginData);
  }

  /**
   * Method to logout from the system
   */
  logout() {
    localStorage.removeItem(TOKEN_NAME);
    return this.apiService.post('/api/account/logout', {});
  }

  /**
   * Method to check if user is authenticated or not
   */
  isAuthenticated(): boolean {
    return !!localStorage.getItem(TOKEN_NAME);
  }
}
